export interface DecisioningStateType {
  type: string;
  headline: string;
  text: string;
  text2?: string;
  image?: string;
  imageAltText?: string;
  buttonText?: string;
}

export interface DecisioningStatesType {
  [key: string]: DecisioningStateType;
}

const DecisioningStatesConfig: DecisioningStatesType = {
  approved: {
    type: 'approvedState',
    headline: 'Approved',
    text: 'You now have the ability to select Purchase Order as a payment method at checkout. To extend access to these terms to other members of your organization, email us at ',
    text2: '. ',
    image: 'https://assets.xometry.com/images/Spot_Cash.svg',
    imageAltText: 'Coins and cash in a pile',
    buttonText: 'Return to Checkout',
  },
  pending: {
    type: 'pendingState',
    headline: 'Request Pending',
    text: 'Your request for Terms with Xometry has been sent and will be reviewed within 1-2 days. You can view the status of your request in Account Settings, and an email will be sent to ',
    text2: ' once a decision has been made.',
    image: 'https://assets.xometry.com/images/Spot_Cash.svg',
    imageAltText: 'Coins and cash in a pile',
  },
  pendingDeclined: {
    type: 'pendingDeclinedState',
    headline: 'Request Pending',
    text: 'Your request for Terms with Xometry has been sent and will be reviewed within 1-2 days. An email will be sent to ',
    text2: ' once a decision has been made.',
    image: 'https://assets.xometry.com/images/Spot_Cash.svg',
    imageAltText: 'Coins and cash in a pile',
  },
  error: {
    type: 'errorState',
    headline: 'Processing Error',
    text: 'There was an issue processing your request for terms. Try again, or contact ',
    text2: ' if the problem persists.',
    image: 'https://assets.xometry.com/images/Spot_Internal_Server_Error.svg',
    imageAltText: 'Vectorized Error',
  },
  loading: {
    type: 'loadingState',
    headline: 'Your request for Xometry Terms is being processed.',
    text: 'It may take a few moments to process your request. Please do not close the window or refresh the page.',
  },
};

export default DecisioningStatesConfig;
